// import React, { Fragment } from 'react';
// import { PropTypes } from 'prop-types';
// import AppHeader from '../../Layout/AppHeader/AppHeader';
// import AppSidebar from '../AppSidebar/AppSidebar';

// export default function AppMain({ children }) {
//   return (
//     <Fragment>
//       <div className="app-container app-theme-white fixed-header fixed-sidebar">
//         <AppHeader />
//         <div className="app-main">
//           <AppSidebar />
//           <div className="app-main__outer">
//             <div className="app-main__inner">{children}</div>
//           </div>
//         </div>
//       </div>
//     </Fragment>
//   );
// }

// AppMain.propTypes = {
//   children: PropTypes.element.isRequired,
// };

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';
import ResizeDetector from 'react-resize-detector';
import AppHeader from '../../Layout/AppHeader/AppHeader';
import AppSidebar from '../AppSidebar/AppSidebar';

class AppMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedSmallerSidebar: true
    };
  }

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
      children
    } = this.props;

    return (
      <ResizeDetector
        handleWidth
        render={({ width }) => (
          <Fragment>
            <div className={cx(
              "app-container app-theme-" + colorScheme,
              { 'fixed-header': enableFixedHeader },
              { 'fixed-sidebar': enableFixedSidebar || width < 1250 },
              { 'fixed-footer': enableFixedFooter },
              { 'closed-sidebar': enableClosedSidebar || width < 1250 },
              { 'closed-sidebar-mobile': closedSmallerSidebar || width < 1250 },
              { 'sidebar-mobile-open': enableMobileMenu },
              { 'body-tabs-shadow-btn': enablePageTabsAlt },
            )}>
              <AppHeader />
              <div className="app-main">
                <AppSidebar />
                <div className="app-main__outer">
                  <div className="app-main__inner">{children}</div>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      />
    )
  }
}

const mapStateToProp = state => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt
});

export default withRouter(connect(mapStateToProp)(AppMain));